import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import CommToolContext from "containers/common/comm_tool_context";
import ProjectTabsList from "../index";
import {Col, Grid, Row} from "react-flexbox-grid";
import ProjectTabRoutes from "../ProjectTabRoutes";

class ProjectTabsNavBar extends Component {

    render() {
        const {history, match, context,project} = this.props;
        const {location} = this.props;

       function getProjectTabStatus(){

            if (location) {
                let pathname = location.pathname;
                if (pathname) {
                    if (pathname.includes("upcoming")) {
                        return "upcoming";
                    } else if (pathname.includes("development")) {
                        return "development";
                    } else if (pathname.includes("release")) {
                        return "release";
                    } else if (pathname.includes("active")) {
                        return "active";
                    } else if (pathname.includes("closed")) {
                        return "closed";
                    } else {
                        return null;
                    }

                }
            }
        }
        let status = getProjectTabStatus();

        return (

            <div>
           <ProjectTabRoutes project={project} context={context} history={history} status={status} />

         <CommToolContext.Consumer>
             {context => (
                 <React.Fragment>
                     <Grid fluid>
                         <Row>
                             <Col xs={12}>
                                 <ProjectTabsList location={status} project={project} context={context} match={match} history={history}/>
                             </Col>
                         </Row>
                     </Grid>
                 </React.Fragment>
             )}
         </CommToolContext.Consumer>

     </div>

    );
    }

}
ProjectTabsNavBar.contextType=ProjectTabsNavBar;
export default withRouter(ProjectTabsNavBar)